import { generateId } from 'src/app/_core/utils/generate-id';
import { FacetsData } from '../models/facets.model';
import { FacetsResponse } from '../models/facets.response';
import { Injectable } from '@angular/core';
import type { FacetsStateModel } from '../facets.state';

@Injectable({
  providedIn: 'root',
})
export class FacetsFactory {
  buildFacetsData(response: FacetsResponse, previousState: FacetsStateModel): FacetsData {
    return {
      sliderTitle: response.sliderTitle,
      facetNames: response.facetNames,
      facetGroups: response.facets?.map((group) => {
        const groupMatched = previousState?.facetGroups.find((g) => g.parentFacet.name === group.parentFacet.name);
        const isParentSelected = groupMatched?.parentFacet.selected ?? false;

        const subFacets = group.subFacets.map((sub) => {
          const subFacetMatched = groupMatched?.subFacets.find((s) => s.name === sub.name);

          return {
            id: subFacetMatched?.id ?? generateId(),
            name: sub.name,
            label: sub.label,
            count: sub.count,
            selected: subFacetMatched?.selected ?? false,
          };
        });

        return {
          parentFacet: {
            id: groupMatched?.parentFacet.id ?? generateId(),
            name: group.parentFacet.name,
            label: group.parentFacet.label,
            count: group.parentFacet.count,
            selected: groupMatched?.parentFacet.selected ?? false,
          },
          subFacets,
          allSelected: isParentSelected || (subFacets.length > 0 && subFacets.every((s) => s.selected)),
          someSelected: subFacets.some((s) => s.selected) && !isParentSelected,
        };
      }),
    };
  }
}
